import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { CustomerService } from '../../services/customer.service';
import { environment } from '../../../environments/environment';
import { CurrentService } from '../../services/current.service';
import { Tools } from 'src/app/services/helpers/tools';
import { TunnelDataState } from '../../stores/tunnel/model/tunnel-data-state';
import { TunnelDataStore } from '../../stores/tunnel/tunnel-data.store';

type DebugObject = {
  customerService: CustomerService;
  tunnelDataState: TunnelDataState;
  configurationData: any;
  currentService: CurrentService;
};

@Component({
  selector: 'ng-casto-debug-infos',
  templateUrl: './debug-infos.component.html'
})
export class DebugInfosComponent implements OnInit {
  version: string;
  subToken: string;
  hasToken: boolean = false;
  msalToken: string;

  debugObj: DebugObject;

  constructor(
    public modalService: ModalService,
    public customer: CustomerService,
    public current: CurrentService,
    public tunnelDataStore: TunnelDataStore
  ) {
    this.version = environment.context + ' / ' + environment.version;
  }

  ngOnInit(): void {
    this.debugObj = {
      customerService: this.customer,
      currentService: this.current,
      tunnelDataState: this.tunnelDataStore.getCurrentStateValue(),
      configurationData: Object.fromEntries(this.tunnelDataStore.getCurrentStateValue().configurationData),
    } as DebugObject;

    this.getToken();
  }

  async getToken() {
    this.hasToken = false;

    if (!this.current.vendor) {
      this.subToken = 'No vendor';
      return;
    }

    this.msalToken = await this.current.vendor.accessToken();

    if (this.msalToken) {
      this.hasToken = true;
      this.subToken = `${this.msalToken.substring(0, 25)}...`;
    } else {
      this.subToken = 'No token';
    }
  }

  copyToken() {
    Tools.copyInClipboard(this.msalToken);
  }
}
